import { axios } from '@Root/API'

export const remove = (engagementId, qualificationAwardId) => {
	return axios.delete(`student-engagement/${engagementId}/qualification-awarded/${qualificationAwardId}`)
}
